var render = function () {
  var _vm$value;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "outlined": "",
      "rounded": "lg"
    }
  }, [_c('div', {
    staticClass: "pa-20 pa-md-24"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "mb-10 mb-md-0",
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('h5', {
    staticClass: "page-text--lg font-weight-medium"
  }, [_vm._v(" " + _vm._s(((_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : _vm$value.name) || "제목없음") + " ")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "4",
      "md": "auto"
    }
  }, [_c('employment-form-preview', _vm._b({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "min-w-md-100px",
          attrs: {
            "outlined": "",
            "small": "",
            "block": "",
            "color": "secondary"
          }
        }, 'v-btn', Object.assign({}, attrs, {
          loading: _vm.loading
        }), false), on), [_c('span', [_vm._v("미리보기")])])];
      }
    }])
  }, 'employment-form-preview', {
    value: _vm.value
  }, false))], 1), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "auto"
    }
  }, [_c('employment-form-form', _vm._b({
    on: {
      "input": function input(value) {
        return _vm.$emit('input', value);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var attrs = _ref2.attrs,
          on = _ref2.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "min-w-md-100px",
          attrs: {
            "outlined": "",
            "small": "",
            "block": "",
            "color": "primary"
          }
        }, 'v-btn', Object.assign({}, attrs, {
          loading: _vm.loading
        }), false), on), [_c('span', [_vm._v("수정")])])];
      }
    }])
  }, 'employment-form-form', {
    value: _vm.value
  }, false))], 1), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "auto"
    }
  }, [_c('v-btn', _vm._b({
    attrs: {
      "outlined": "",
      "small": "",
      "block": "",
      "color": "grey-d"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('remove', _vm.value);
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("삭제")])])], 1)], 1)], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }